<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

@if (range) {
	<mat-form-field [ngClass]="{ disabled: disabled || isDisabled }">
		<mat-label>{{ label }}</mat-label>

		<mat-date-range-input
			[rangePicker]="picker"
			[disabled]="disabled || isDisabled"
			[min]="minDate"
		>
			<input
				matStartDate
				(input)="onDateInput($event, 'start')"
				(dateChange)="onStartDateChange($event)"
				placeholder="From"
				[formControl]="selectedStartDate"
				[attr.disabled]="disabled || isDisabled"
			/>

			<input
				matEndDate
				(input)="onDateInput($event, 'end')"
				(dateChange)="onEndDateChange($event)"
				placeholder="To"
				[formControl]="selectedEndDate"
				[attr.disabled]="disabled || isDisabled"
			/>
		</mat-date-range-input>

		<mat-datepicker-toggle
			matIconSuffix
			[for]="picker"
			[disabled]="disabled || isDisabled"
		>
			<span
				matDatepickerToggleIcon
				class="icon-calendar"
			></span>
		</mat-datepicker-toggle>

		<mat-date-range-picker
			#picker
			[disabled]="disabled || isDisabled"
		>
			<mat-datepicker-actions>
				<div class="datepicker-actions">
					<button
						mat-button
						matDatepickerCancel
						class="datepicker-btn"
						(click)="clearSelection()"
					>
						Clear
					</button>

					<div>
						<button
							mat-button
							matDatepickerCancel
							class="datepicker-btn"
						>
							Cancel
						</button>

						<button
							mat-button
							matDatepickerApply
							class="datepicker-btn"
							(click)="onRangeSelection()"
						>
							Ok
						</button>
					</div>
				</div>
			</mat-datepicker-actions>
		</mat-date-range-picker>

		@if (isInvalid) {
			<mat-hint>Invalid input</mat-hint>
		}
	</mat-form-field>
} @else {
	<mat-form-field [ngClass]="{ disabled: disabled || isDisabled }">
		<mat-label>{{ label }}</mat-label>

		<input
			matInput
			[min]="minDate"
			[value]="selection"
			[matDatepicker]="picker"
			[formControl]="selectedDate"
			(blur)="onTouched()"
			(input)="onDateInput($event)"
			(dateChange)="onDateChange($event)"
			[attr.disabled]="disabled || isDisabled"
		/>

		<mat-datepicker-toggle
			matIconSuffix
			[for]="picker"
			[disabled]="disabled || isDisabled"
		>
			<span
				matDatepickerToggleIcon
				class="icon-calendar"
			></span>
		</mat-datepicker-toggle>

		<mat-datepicker
			#picker
			[disabled]="disabled || isDisabled"
		>
			<mat-datepicker-actions>
				<div class="datepicker-actions">
					<button
						mat-button
						matDatepickerCancel
						class="datepicker-btn"
						(click)="clearSelection()"
					>
						Clear
					</button>

					<div>
						<button
							mat-button
							matDatepickerCancel
							class="datepicker-btn"
						>
							Cancel
						</button>

						<button
							mat-button
							matDatepickerApply
							class="datepicker-btn"
						>
							Ok
						</button>
					</div>
				</div>
			</mat-datepicker-actions>
		</mat-datepicker>

		@if (isInvalid) {
			<mat-hint>Invalid input</mat-hint>
		}
	</mat-form-field>
}
